import React, { useEffect, useMemo, useState } from 'react';
import BlogCard from './BlogCard';
import SeoHelmet from "../components/SeoHelmet";
import ContactModal from "../components/ContactModal";
import slide1 from '../assets/img/blog_banner.jpg';

// ====== CONFIG ======
const API_BASE = "https://workdayz.in/formdata";                // <-- अपने डोमेन से बदलें
const API_LIST = `${API_BASE}/api_blog_list.php`;          // <-- वही PHP API (list + pagination)

// तारीख को "25 August 2025" फॉर्मेट में
const prettyDate = (iso) => {
  try {
    return new Date(iso).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  } catch { return iso || ""; }
};

// API rows -> BlogCard shape
const mapRow = (row) => {
  const image = row.image
    ? row.image
    : row.cover_path
    ? `${API_BASE}/${row.cover_path}`
    : "";

  return {
    id: row.id,
    title: row.title,
    excerpt: row.excerpt || "",
    image,
    author: row.author ? `By ${row.author}` : "By admin",
    date: prettyDate(row.created_at || row.date),
    link: `/blog/${row.slug}`,
  };
};

const Blog = () => {
  const postsPerPage = 9; // प्रति पेज 9 (आपकी पुरानी सेटिंग)
  const [currentPage, setCurrentPage] = useState(1);

  const [posts, setPosts] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  // API से डेटा
  useEffect(() => {
    const controller = new AbortController();

    const load = async () => {
      setLoading(true);
      setErr("");
      try {
        const url = new URL(API_LIST);
        url.searchParams.set("page", currentPage);
        url.searchParams.set("limit", postsPerPage);
        // चाहें तो search param भी भेज सकते हैं: url.searchParams.set("q", "");

        const res = await fetch(url, { signal: controller.signal });
        const json = await res.json();

        if (!json?.success) throw new Error("Failed to load");
        const rows = Array.isArray(json.data) ? json.data : [];
        setPosts(rows.map(mapRow));
        setTotalPages(json.total_pages || 1);
      } catch (e) {
        if (e.name !== "AbortError") setErr("Failed to load blogs.");
      } finally {
        setLoading(false);
      }
    };

    load();
    return () => controller.abort();
  }, [currentPage]);

  // Utility: Group posts into chunks of 3 (1 big + 2 small)
  const chunkArray = (arr, size) => {
    const chunks = [];
    for (let i = 0; i < arr.length; i += size) {
      chunks.push(arr.slice(i, i + size));
    }
    return chunks;
  };

  const chunkedPosts = useMemo(() => chunkArray(posts, 3), [posts]);

  return (
    <>
      <SeoHelmet />
      <ContactModal />

      <section>
        <div className="swiper animeslide">
          <div className="swiper-wrapper">
            <div
              className="swiper-slide animeslide-slide slide1 design_banner"
              style={{ backgroundImage: `url(${slide1})` }}
            >
              <div className="container">
                <div className="row">
                  <div className="col-sm-12 banner_content">
                    <div className="content-slide">
                      <div data-animate="bottom" className="animeslide-heading">
                        <h2>Blog</h2>
                        {/* <p>Lorem Ipsum is a dummy text</p> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex animeslide-bottom">
            <div className="animeslide-pagination swiper-pagination"></div>
          </div>
        </div>
      </section>

      <section className="blog">
        <div className="container">
          {loading && (
            <div style={{ textAlign: 'center', padding: '24px' }}>Loading…</div>
          )}
          {err && !loading && (
            <div style={{ textAlign: 'center', padding: '24px', color: 'tomato' }}>{err}</div>
          )}
          {!loading && !err && chunkedPosts.map((chunk, rowIndex) => {
            const [bigPost, smallPost1, smallPost2] = chunk;
            if (!bigPost) return null;
            const isEven = rowIndex % 2 === 0;

            return (
              <div className="row blogg" key={bigPost.id}>
                {isEven ? (
                  // Even row: Big left, small right
                  <>
                    <div className="col-sm-8 ">
                      <BlogCard post={bigPost} height="690px" />
                    </div>
                    <div className="col-sm-4 colrevmbr">
                      {smallPost1 && (
                        <BlogCard post={smallPost1} height="330px" style={{ marginBottom: '30px' }} />
                      )}
                      {smallPost2 && (
                        <BlogCard post={smallPost2} height="330px" />
                      )}
                    </div>
                  </>
                ) : (
                  // Odd row: Small left, big right
                  <>
                    <div className="col-sm-4 colrevmbr">
                      {smallPost1 && (
                        <BlogCard post={smallPost1} height="330px" style={{ marginBottom: '30px' }} />
                      )}
                      {smallPost2 && (
                        <BlogCard post={smallPost2} height="330px" />
                      )}
                    </div>
                    <div className="col-sm-8 ">
                      <BlogCard post={bigPost} height="690px" />
                    </div>
                  </>
                )}
              </div>
            );
          })}

          {/* Pagination Controls */}
          {!loading && !err && (
            <div style={{ textAlign: 'center', marginTop: '20px' }}>
              {Array.from({ length: totalPages }, (_, i) => (
                <button
                  key={i}
                  onClick={() => setCurrentPage(i + 1)}
                  style={{
                    margin: '0 5px',
                    padding: '8px 12px',
                    background: 'transparent',
                    color: '#fff',
                    border: 'none',
                    borderBottom: currentPage === i + 1 ? '2px solid #fff' : '2px solid transparent',
                    fontWeight: currentPage === i + 1 ? 'bold' : 'normal',
                    cursor: 'pointer',
                  }}
                >
                  {i + 1}
                </button>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default Blog;
